import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e53336ce"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tk-lottery-boxs"
};
const _hoisted_2 = {
  class: "tk-lottery-code"
};
const _hoisted_3 = {
  class: "tk-code-title flex-between"
};
const _hoisted_4 = {
  class: "code-title"
};
const _hoisted_5 = {
  class: "code-tiems"
};
const _hoisted_6 = {
  class: "tk-lottery-box"
};
const _hoisted_7 = {
  class: "sx"
};
const _hoisted_8 = {
  class: "te_attr"
};
const _hoisted_9 = {
  class: "info_item"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info_item_title"
}, "特码单双", -1));
const _hoisted_11 = {
  class: "info_item_content"
};
const _hoisted_12 = {
  class: "info_item"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info_item_title"
}, "特码大小", -1));
const _hoisted_14 = {
  class: "info_item_content c"
};
const _hoisted_15 = {
  class: "info_item"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info_item_title"
}, "总和大小", -1));
const _hoisted_17 = {
  class: "info_item_content"
};
const _hoisted_18 = {
  class: "info_item"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info_item_title"
}, "总和单双", -1));
const _hoisted_20 = {
  class: "info_item_content c"
};
const _hoisted_21 = {
  class: "tk-box-recommend"
};
const _hoisted_22 = {
  class: "tk-recommend-title"
};
const _hoisted_23 = {
  class: "title"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "推荐", -1));
const _hoisted_25 = {
  class: "tk-recommend-content"
};
const _hoisted_26 = {
  class: "flex-between"
};
const _hoisted_27 = {
  class: "tk-cont-l"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "九肖：", -1));
const _hoisted_29 = {
  class: "tk-cont-r"
};
const _hoisted_30 = {
  class: "flex-between"
};
const _hoisted_31 = {
  class: "tk-cont-l"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "六肖：", -1));
const _hoisted_33 = {
  class: "tk-cont-r"
};
const _hoisted_34 = {
  class: "flex-between"
};
const _hoisted_35 = {
  class: "tk-cont-l"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "四肖：", -1));
const _hoisted_37 = {
  class: "tk-cont-r"
};
const _hoisted_38 = {
  class: "flex-between"
};
const _hoisted_39 = {
  class: "tk-cont-l"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "一肖：", -1));
const _hoisted_41 = {
  class: "tk-cont-r"
};
const _hoisted_42 = {
  class: "flex-between"
};
const _hoisted_43 = {
  class: "tk-cont-l"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "十码：", -1));
const _hoisted_45 = {
  class: "tk-cont-r"
};
const _hoisted_46 = {
  class: "tk-box-other"
};
const _hoisted_47 = {
  class: "name"
};
const _hoisted_48 = {
  class: "cont"
};
import { lotteryrecord } from '@/utils/https/page';
import { onBeforeMount, reactive, toRef } from 'vue';

import { useRoute } from 'vue-router';
import { ref } from 'vue';
export default {
  __name: 'historyDesc',
  setup(__props) {
    const route = useRoute();
    let numarray = ref({});
    let recommend = ref([]);

    // let {numarray} = toRef(data)

    onBeforeMount(() => {
      let id = route.query.id;
      lotteryrecords(id);
    });
    let lotteryrecords = id => {
      lotteryrecord({
        id: id
      }).then(res => {
        let lotteryTime;
        let datas = res.data.data;
        lotteryTime = datas.lotteryTime.split('-');
        datas.lotteryTime = `${lotteryTime[0]}年${lotteryTime[1]}月${lotteryTime[2]}日`;
        datas.oddEven_t = datas.te_attr.oddEven;
        datas.bigSmall_t = datas.te_attr.bigSmall;
        datas.oddEven = datas.total_attr.oddEven;
        datas.bigSmall = datas.total_attr.bigSmall;
        recommend.value = datas.recommend;
        numarray.value = datas;
      });
    };
    return (_ctx, _cache) => {
      const _component_headNav = _resolveComponent("headNav");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_headNav, {
        title: "开奖详情"
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, "第" + _toDisplayString(_unref(numarray).issue) + "期最新开奖结果", 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(numarray).lotteryTime), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(numarray).number_attr, (items, indexs) => {
        return _openBlock(), _createElementBlock("li", {
          key: indexs
        }, [_createElementVNode("div", {
          class: _normalizeClass('class' + items.color + ' num')
        }, [_createElementVNode("span", null, _toDisplayString(items.number), 1)], 2), _createElementVNode("div", _hoisted_7, _toDisplayString(items.shengXiao) + _toDisplayString('/' + items.wuXing), 1)]);
      }), 128))])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(numarray).oddEven_t), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(numarray).bigSmall_t), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(numarray).oddEven), 1)]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(numarray).bigSmall), 1)])])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("span", null, _toDisplayString(_unref(numarray).year), 1), _createElementVNode("b", null, "第" + _toDisplayString(_unref(numarray).issue) + "期", 1), _hoisted_24])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("ul", null, [_createElementVNode("li", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_hoisted_28, _createTextVNode(_toDisplayString(_unref(recommend).nine_xiao), 1)]), _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(recommend).nine_is_win == 1 ? '中奖' : ''), 1)]), _createElementVNode("li", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_hoisted_32, _createTextVNode(_toDisplayString(_unref(recommend).six_xiao), 1)]), _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(recommend).six_is_win == 1 ? '中奖' : ''), 1)]), _createElementVNode("li", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_hoisted_36, _createTextVNode(_toDisplayString(_unref(recommend).four_xiao), 1)]), _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(recommend).four_is_win == 1 ? '中奖' : ''), 1)]), _createElementVNode("li", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_hoisted_40, _createTextVNode(_toDisplayString(_unref(recommend).one_xiao), 1)]), _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(recommend).one_is_win == 1 ? '中奖' : ''), 1)]), _createElementVNode("li", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_hoisted_44, _createTextVNode(_toDisplayString(_unref(recommend).ten_ma), 1)]), _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(recommend).te_is_win == 1 ? '中奖' : ''), 1)])])])]), _createElementVNode("div", _hoisted_46, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(numarray).attr, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (value, key) => {
          return _openBlock(), _createElementBlock("div", {
            key: key
          }, [_createElementVNode("div", _hoisted_47, _toDisplayString(key) + " : ", 1), _createElementVNode("div", _hoisted_48, _toDisplayString(value), 1)]);
        }), 128))]);
      }), 128))])])])], 64);
    };
  }
};